export const ScatteredShowersNightIcon = () => (
    <svg
        tabIndex={-1}
        focusable="false"
        className="svg-icon icon-weather"
        width="80px"
        height="80px"
        fill="none"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g className="weather-fill" id="45" fill="#3F4447">
                <g transform="translate(2.000000, 10.000000)">
                    <path
                        d="M3.667 40.402c0 8.498 6.988 15.377 15.596 15.377h45.653C71.585 55.78 77 50.448 77 43.86c0-2.586-.838-5.05-2.365-7.085a1.55 1.55 0 00-2.479 1.86 8.667 8.667 0 011.746 5.225c0 4.867-4.018 8.822-8.986 8.822H19.263c-6.907 0-12.497-5.503-12.497-12.279 0-6.518 5.188-11.9 11.793-12.26a1.55 1.55 0 001.456-1.384c.79-7.535 7.274-13.326 15.051-13.326 6.416 0 12.065 3.96 14.223 9.782a1.55 1.55 0 002.905-1.077c-2.606-7.034-9.412-11.804-17.128-11.804-8.92 0-16.442 6.347-17.954 14.837-7.619 1.036-13.445 7.483-13.445 15.232z"
                        fill="#717277"
                    />
                    <path
                        d="M67.027 10.404c1.531.158 1.92 2.21.554 2.917a8.709 8.709 0 003.997 16.449 8.68 8.68 0 003.2-.607c1.433-.566 2.724 1.077 1.836 2.335a13.41 13.41 0 01-10.975 5.69c-7.415 0-13.427-6.012-13.427-13.428 0-7.415 6.011-13.427 13.427-13.427.466 0 .929.024 1.388.071zM55.31 23.761c0 5.704 4.625 10.328 10.33 10.328 1.769 0 3.462-.447 4.95-1.261-6.058-.502-10.82-5.579-10.82-11.767 0-2.58.836-5.012 2.292-6.993-3.941 1.455-6.752 5.246-6.752 9.693z"
                        fill="#717277"
                    />
                    <path
                        d="M33.656 64.13a1.55 1.55 0 00-2.191-2.19l-5.113 5.112a1.55 1.55 0 002.191 2.191l5.113-5.112zM54.313 64.13a1.55 1.55 0 00-2.19-2.19l-5.113 5.112a1.55 1.55 0 002.19 2.191l5.113-5.112z"
                        fill="#9ADAFF"
                    />
                </g>
            </g>
        </g>
    </svg>
);
